import React, { VFC, FocusEvent, ChangeEvent, useState } from "react"

import { ValueFieldProps } from "@sitecore-jss/sitecore-jss-react-forms/types"

const CheckboxField: VFC<ValueFieldProps> = (props) => {
  const { field, tracker } = props
  const hasAnyError = !!props.errors?.length
  const FieldValidationErrors = props.fieldValidationErrorsComponent
  const label = field.model.title
  const id = field.valueField.id
  const name = field.valueField.name
  const [IsChecked, ChangedChecked] = useState(props.value)

  const onFocus = (e: FocusEvent<HTMLInputElement>) => {
    tracker.onFocusField(field, e.target.value)
  }

  const onBlur = (e: FocusEvent<HTMLInputElement>) => {
    tracker.onBlurField(field, e.target.value)
  }

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    ChangedChecked(e.target.checked?.toString())
    props.onChange(
      field.valueField.name,
      e.target.checked?.toString(),
      props.isValid,
      []
    )
  }

  return (
    <div>
      <div
        className={`sitecore-jss-form__control sitecore-jss-form__control--checkboxprivacy ${
          hasAnyError ? "sitecore-jss-form__control--has-error" : ""
        }`}
        id='checkboxprivacy'
      >        
        <label htmlFor={id} className="checkboxprivacy-checkbox">
        <input
           id={id}
           name={name}
           className='sitecore-jss-form__control--checkbox'
           onFocus={onFocus}
           onBlur={onBlur}
           type='checkbox'
           onChange={onChange}
           value={IsChecked}
           checked = {IsChecked === "true"}
         />
        </label>
        <label className='sitecore-jss-form__label--policy'>{label}</label>
      </div>
      <FieldValidationErrors {...props} />
    </div>
  )
}

export default CheckboxField
